import { render, staticRenderFns } from "./url_shortener.vue?vue&type=template&id=5bfba028&scoped=true&"
import script from "./url_shortener.vue?vue&type=script&lang=js&"
export * from "./url_shortener.vue?vue&type=script&lang=js&"
import style0 from "./url_shortener.vue?vue&type=style&index=0&id=5bfba028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfba028",
  null
  
)

export default component.exports